import { Component, OnDestroy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ContactscreenCoreService } from 'src/app/@root-redux/contactscreen/services/contactscreen.service';
import { URL_DOMAIN, environment } from 'src/environments/environment';
import { NavigatorService } from '../../services/navigator/navigator.service';
import { Observable, Subject } from 'rxjs';
import { FaqsService } from 'src/app/core/services/faqs-service/faqs.service';
import { ChatFrom } from '../../constants/chatFrom';

@Component({
  selector: 'appmobile-navbar',
  templateUrl: './appmobile-navbar.component.html',
  styleUrls: ['./appmobile-navbar.component.scss'],
})
export class AppMobileNavBarComponent implements OnDestroy {
  showMenu: any = false;
  path: string = '';
  isChatbotInit = false;

  private destroyed$ = new Subject<void>();
  showBackArrow$!: Observable<boolean>;
  showChatButton$!: Observable<boolean>;
  router = inject(Router);
  faqsService = inject(FaqsService);
  navigatorService = inject(NavigatorService);
  contactscreenCoreService = inject(ContactscreenCoreService);
  public deeplink!: string;
  private initialUrl!: string;

  constructor() {
    this.showBackArrow$ = this.navigatorService.showArrow$;
    this.showChatButton$ = this.navigatorService.showChatButton$;
    this.deeplink = this.navigatorService.getDeeplink();
    this.initialUrl = this.navigatorService.getInitialUrl();
  }

  ngOnDestroy(): void {
    this.destroyed$?.next();
    this.destroyed$?.complete();
  }

  goBack(): void {
    const url = this.router.url.split('?')[0];

    if (this.deeplink && this.initialUrl === window.location.href)
      return this.externalNavigation(this.deeplink);

    if (url === environment.homePath) {
      this.externalNavigation(environment.homeRedirect);
    } else {
      history.back();
    }
  }

  externalNavigation(path: string): void {
    window.location.href = path;
  }

  get isApp(): boolean {
    return this.navigatorService.isApp;
  }

  exit(): void {
    window.open(URL_DOMAIN, '_self');
  }

  openChat(): void {
    this.router.navigate(['/chat'], {
      state: {
        chatFrom: ChatFrom.CHAT_ICON_NAVBAR,
      },
    });
  }

  setMenuStatus(value: boolean): void {
    this.showMenu = value;
  }
}
